import { useEffect } from 'react';
import { useBusinessInfo } from '@/hooks/useTenantSettings';
import { setAppFavicon } from '@/utils/favicon';

/** Keeps the tenant favicon in sync on every authenticated route. */
export function FaviconSync() {
  const { data } = useBusinessInfo();

  useEffect(() => {
    const logo = data?.logo?.trim();
    if (logo) setAppFavicon(logo);
  }, [data?.logo]);

  return null;
}
